var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-6"},[_c('e-hint',{attrs:{"title":_vm.$t(_vm.getErrorContent),"variant":"danger","dismissible":""},on:{"input":function($event){return _vm.closeError()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }